import styles from './web-updates-grid.module.scss';
import { useTableConfigHook } from '../../requestUtils';
import { CreateHeaders, textHeader, HeaderSizeEnum, dateAndTimeHeader } from '@frontend-workspace/react-shared-lib';
import { ValueFormatterParams } from 'ag-grid-community';
import { DateRange } from '@mui/x-date-pickers-pro/DateRangePicker';
import { IWebUpdates } from '../../_models/web-updates';
import { WebkuaTable } from '@frontend-workspace/webkua-lib';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface WebUpdatesGridProps {
  webUpdates: IWebUpdates[],
  onDateChange: (dateRange: DateRange<Date> | null) => void,
  onRefresh: () => void,
  isLoading: boolean,
  dateRange: DateRange<Date>
}

export function WebUpdatesGrid(props: WebUpdatesGridProps) {
  const { t } = useTranslation();
  const tableConfig = useTableConfigHook("webUpdates");
  const byteRenderer = (params: ValueFormatterParams) => `${(params.value / 1000000).toFixed()} MB`;
  const milisecRenderer = (params: ValueFormatterParams) => `${(params.value / 1000).toFixed()} ${t("webUpdates.seconds")}`;

  return (
    <WebkuaTable
      dateRange={props.dateRange}
      isLoading={props.isLoading}
      onRefresh={props.onRefresh}
      headers={CreateHeaders([
        textHeader("companyNumber", t("standard.companyNumber"), HeaderSizeEnum.MEDIUM),
        textHeader("companyName", t("standard.company"), HeaderSizeEnum.LARGE),
        textHeader("productName", t("standard.productName"), HeaderSizeEnum.LARGE),
        dateAndTimeHeader("date", t("standard.date")),
        textHeader("windowsUserName", t("standard.user"), HeaderSizeEnum.LARGE),
        textHeader("domainName", t("standard.domain"), HeaderSizeEnum.LARGE),
        textHeader("computerName", t("standard.machine"), HeaderSizeEnum.LARGE),
        textHeader("files", t("webUpdates.files"), HeaderSizeEnum.LARGE, {
          cellStyle: { justifyContent: 'right' },
          headerClass: "ag-right-aligned-header"
        }),
        textHeader("bytes", t("webUpdates.size"), HeaderSizeEnum.MEDIUM, {
          renderer: byteRenderer,
          cellStyle: { justifyContent: 'right' },
          headerClass: "ag-right-aligned-header"
        }),
        textHeader("miliseconds", t("standard.duration"), HeaderSizeEnum.MEDIUM, {
          renderer: milisecRenderer,
          cellStyle: { justifyContent: 'right' },
          headerClass: "ag-right-aligned-header"
        })
      ])}
      data={props.webUpdates}
      tableConfig={tableConfig}
      onSetDateRange={props.onDateChange}
    />
  );
}

export default WebUpdatesGrid;